import { CheckCircledIcon } from '@radix-ui/react-icons'
import { IconArrowAutofitContent, IconArrowRight, IconArrowsDiagonal } from '@tabler/icons-react'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function CtaBewertenPoll() {
    const navigate = useNavigate();
  return (
    <div>
        <div className='flex flex-col-reverse md:flex-row w-full relative overflow-hidden  rounded-lg md:h-full'>
        <div className='md:w-6/12  bg-prime-900 flex flex-col justify-between text-white p-5 md:p-10 py-10 md:py-16'>
            <h2 className="lg:text-4xl md:text-3xl sm:text-xl lg:leading-relaxed font-bold font-serif mb-4">Erhalten Sie Ihr kostenloses Marktwert-PDF</h2>
            <p className="text-gray-100 lg:text-xl md:text-lg lg:leading-8 font-light text-wrap max-w-[40rem] w-full mb-6">In nur wenigen Klicks zur fundierten Immobilienbewertung: Geben Sie einfach die Eckdaten Ihrer Immobilie an und erhalten Sie eine detaillierte Analyse mit Marktwert, Nachbarschaftsvergleich, Preisentwicklungen und aktuellen Trends. Sehen Sie, welche ähnlichen Immobilien in Ihrer Umgebung angeboten wurden – für eine erste, verlässliche Einschätzung.</p>
            <div className='mb-6'>
                <div className="flex items-center gap-5 mb-4">
                    <CheckCircledIcon className=' text-lime-400 w-5 h-5'/>
                    <p className="text-sm text-white font-light">Schnell & einfach </p>
                </div>
                <div className="flex items-center gap-5 mb-4">
                    <CheckCircledIcon className=' text-lime-400 w-5 h-5'/>
                    <p className="text-sm text-white font-light">Detaillierte Marktanalyse</p>
                </div>
                <div className="flex items-center gap-5 mb-4">
                    <CheckCircledIcon className=' text-lime-400 w-5 h-5'/>
                    <p className="text-sm text-white font-light">100% kostenlos und unverbindlich</p>
                </div>
            </div>
            <Link
                to={"/bewerten/immobilie/online-bewertung"}
                className=" flex items-center justify-between py-3 px-8 bg-prime-200 cursor-pointer text-prime-950 rounded hover:bg-prime-300 transition-colors"
            >
                
                Jetzt bewerten
                <IconArrowRight className='inline ml-2 w-5 h-5'/>
            </Link>
           
        </div>
        <div  className='md:w-6/12'>
            <img className='h-full max-h-[20rem] md:max-h-none object-cover bg-transparent' src="/Fotos/bewertung-marktwert-jakobs.jpg" alt="Ein Bild von einem Gerätmockup mit einem Expose-Beispiel" />
        </div>
        </div>
    
    </div>
  )
}
